import { Component, Input } from "@angular/core";
import { FaultSyncState } from "@docma-mm-core/fault/fault-sync-state";
import { SyncStatusEnum } from "@docma-mm-core/model/sync-state/sync-status.enum";

@Component({
    selector: 'mydocma-mm-faults-sync-status-tile',
    templateUrl: './mm-faults-sync-status-tile.component.html',
    styleUrls: ['./mm-faults-sync-status-tile.component.scss'],
    providers: []
  })
  export class MmFaultsSyncStatusTileComponent {

    public syncStatus = SyncStatusEnum;

    @Input() syncState: FaultSyncState

  }